require('../../modules/es6.number.is-finite');
module.exports = require('../../modules/_core').Number.isFinite;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/number/is-finite.js
// module id = k2Ib
// module chunks = 2